import moment from 'moment';
import { LUDUM_CALENDAR_VIEWS } from '@/constants';

export const profileCalendar = {
    namespaced: true,

    state: {
        currentDate: moment(),
        calendarView: LUDUM_CALENDAR_VIEWS.MONTH,
        agendaItems: [],

        filter: {
            athlete_ids: [],
            start_date: moment(),
            end_date: moment()
        }
    },

    getters: {
        agendaItems(state) {
            return _.sortBy(state.agendaItems, 'start_date');
        },
        currentDate(state) {
            return state.currentDate;
        },
        calendarView(state) {
            return state.calendarView;
        },
        filter(state) {
            return state.filter;
        }
    },

    mutations: {
        setAthlete(state, athleteId) {
            state.filter.athlete_ids = [athleteId];
        },

        saveWeeklySummaryMonth(state, month) {
            state.weeklySummaryMonth = month;
        },

        saveCurrentDate(state, date) {
            state.currentDate = date;
        },

        saveCurrentView(state, view) {
            state.calendarView = view;
        },

        agendaItems(state, data) {
            state.agendaItems = [];
            _.each(data, item => {
                if (!_.some(state.agendaItems, { id: item.id })) {
                    state.agendaItems.push(item);
                }
            });
        }
    }
};
